import { gql } from "@apollo/client";

export const RISK_COMMENT_UPDATED = gql`
  subscription riskCommentUpdated($documentId: Int!, $siteId: Int!) {
    riskCommentUpdated(documentId: $documentId, siteId: $siteId) {
      documentId
      siteId
    }
  }
`;
